import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { FileField, FileInput, ImageField, LinearProgress, useDataProvider } from 'react-admin'
import { useInput } from 'react-admin'

const ReferenceFileInput = ({ source, reference, accept, srcPath, titlePath, ...props }) => {
    const [fileData, setFileData] = useState(null)
    const [loading, setLoading] = useState(true)
    const dataProvider = useDataProvider()
    const PreviewField = accept && accept.includes('image') ? ImageField : FileField

    const { field } = useInput({ source })

    useEffect(() => {
        if (null === field) {
            return
        }

        if ('string' !== typeof field.value) {
            return
        }

        dataProvider.getOne(reference, { id: field.value }).then(({ data }) => {
            setFileData(data)
            setLoading(false)
        })
    }, [])

    return (
        <FileInput
            field={field}
            source={source}
            reference={reference}
            {...props}
            format={(value) => {
                if (value && value.rawFile) return value
                if (fileData)
                    return {
                        src: fileData[srcPath],
                        title: fileData[titlePath],
                    }

                return {}
            }}>
            {!loading ? <PreviewField source='src' /> : <LinearProgress />}
        </FileInput>
    )
}

ReferenceFileInput.propTypes = {
    label: PropTypes.string,
}

export default ReferenceFileInput
